import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  useEffect(() => {
    let count = 0;
    let hideTimer: number | undefined;
    let interval: number | undefined;
    const show = () => {
      setIndex(count % recentPurchases.length);
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const purchase = index === null ? null : recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" data-id="element-189" data-mp="164oa074zg5up">
      <AnimatePresence data-id="element-190" data-mp="116cylrz1hnad">
        {purchase && <motion.a key={index} href={offerAnchor} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[290px] items-center gap-3 rounded-xl border-[3px] border-brand-light bg-navy p-3 shadow-2xl shadow-navy/40" data-id="element-191" data-mp="1fwbwdtmomwpb">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-192" data-mp="s67sdl5l0uxs">
              <ShoppingBagIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-193" data-mp="28kg6qsg77xyc" />
            </span>
            <span className="min-w-0 text-left" data-id="element-194" data-mp="23ln11m75lb8q">
              <span className="block text-sm font-extrabold leading-tight text-white" data-id="element-195" data-mp="23kv3w6xwr5gc">
                {purchase.name}{' '}
                <span className="font-semibold text-white/80" data-id="element-196" data-mp="2aqnxd5b62jbo">
                  from {purchase.city}, {purchase.country}
                </span>
              </span>
              <span className="mt-0.5 block text-xs text-white/80" data-id="element-197" data-mp="2ko294rm5ajxn">
                just purchased the Complete Injury Rehabilitation Bundle
              </span>
              <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-wider text-brand-light" data-id="element-198" data-mp="1rybumhglpg10">
                {purchase.time}
              </span>
            </span>
          </motion.a>}
      </AnimatePresence>
    </div>;
}